import { render, staticRenderFns } from "./BasicDragablePanel.vue?vue&type=template&id=3dc2ded0&scoped=true"
import script from "./BasicDragablePanel.vue?vue&type=script&lang=js"
export * from "./BasicDragablePanel.vue?vue&type=script&lang=js"
import style0 from "./BasicDragablePanel.vue?vue&type=style&index=0&id=3dc2ded0&prod&lang=scss&scoped=true"
import style1 from "./BasicDragablePanel.vue?vue&type=style&index=1&id=3dc2ded0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2ded0",
  null
  
)

export default component.exports